import { useState } from "react";
import { msg } from "@lingui/core/macro";
import { createFileRoute } from "@tanstack/react-router";

import { AuthoFormSteps } from "@/constants/auth";
import { parseSEOMetaLoaderData, seo } from "@/lib/seo";
import EmailVerificationForm from "@/components/forms/email-verification-form";
import LoginForm from "@/components/forms/login-form";

export const Route = createFileRoute("/_minimal-layout/_auth-layout/login")({
  loader: ({ context: { i18n } }) => {
    return {
      seoMeta: seo({
        i18n,
        title: msg`Login`,
        description: msg`Sign in to your El Safwa account to access your bookings, manage your profile, and explore our exclusive properties.`,
      }),
    };
  },
  head: ({ loaderData }) => ({
    meta: [
      ...parseSEOMetaLoaderData(loaderData, {
        title: "Login",
      }),
    ],
  }),
  component: RouteComponent,
});

function RouteComponent() {
  const [authFlow, setAuthFlow] = useState({
    email: "",
    currentStep: AuthoFormSteps.LOGIN as AuthoFormSteps,
  });

  if (authFlow.currentStep === AuthoFormSteps.OTP)
    return <EmailVerificationForm authFlow={authFlow} />;

  return <LoginForm setAuthFlow={setAuthFlow} />;
}
